<template>
  <div class="joblistwidget">
    <Container
      v-if="jobs && jobs.total > 0"
      class="has-jobs"
      width="medium"
      spacing="jobwidget"
      background-color="#F5F7FA"
    >
      <div v-for="job in jobs.docs" :key="job.id" class="my-10">
        <JobsListWidgetItem :key="job.id" :job="job" />
      </div>
      <b-row class="justify-content-center mt-24">
        <p class="powered-by">Widget powered by thehub.io</p>
      </b-row>
    </Container>
    <Container
      v-else
      width="big"
      background-color="#F5F7FA"
      spacing="jobwidget"
      class="no-positions"
    >
      <b-col>
        <b-row class="justify-content-center mb-8">
          <img width="27px" height="32px" src="~/assets/components/jobs/mug.svg" />
        </b-row>
        <b-row class="justify-content-center mb-8">
          <h3 class="fs16">No open positions at the moment</h3>
        </b-row>
        <b-row class="justify-content-center">
          <p class="powered-by">Widget powered by thehub.io</p>
        </b-row>
      </b-col>
    </Container>
  </div>
</template>

<script>
import Container from '@/components/Container';
import JobsListWidgetItem from '@/components/jobs/JobsListWidgetItem';
import JobModel from '@/models/Job';

export default {
  name: 'JobListWidget',
  components: {
    JobsListWidgetItem,
    Container
  },
  layout() {
    return 'joblistwidget';
  },
  data() {
    return {
      jobs: null
    };
  },
  computed: {
    startup() {
      return this.$store.state.startups.startup;
    }
  },
  async asyncData({ params, store, $axios, error }) {
    try {
      // console.log(params)
      const [, jobs] = await Promise.all([
        store.dispatch('startups/get', params.id),
        $axios.get('/companies/' + params.id + '/jobs', {
          params: {
            limit: 100
          }
        })
      ]);

      return { jobs: jobs.data };
    } catch (err) {
      error(err);
    }
  },
  mounted() {
    this.$gtm.push({
      event: 'ga.event',
      category: 'joblistwidget',
      action: 'JobListWidgetCreated',
      label: this.startup.key
    });
  },
  head() {
    return {
      meta: [
        {
          name: 'robots',
          content: 'noindex'
        }
      ]
    };
  },
  created() {
    this.jobs = {
      ...this.jobs,
      docs: this.jobs.docs.map((doc) => new JobModel(doc))
    };
  }
};
</script>
<style scoped lang="scss">
.joblistwidget {
  .powered-by {
    color: $gray-600;
    font-size: rem(12px);
  }

  .no-positions {
    display: flex;
    justify-content: center;
    color: $gray-600;

    h3 {
      font-weight: 500;
    }
  }
}
</style>
